import { createContext, useContext, ReactNode } from "react";
import { appsAPI, blogsAPI, contactsAPI, adminAPI } from "../services/api";

interface ApiContextType {
  apps: typeof appsAPI;
  blogs: typeof blogsAPI;
  contacts: typeof contactsAPI;
  admin: typeof adminAPI;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  const value: ApiContextType = {
    apps: appsAPI,
    blogs: blogsAPI,
    contacts: contactsAPI,
    admin: adminAPI,
  };

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within ApiProvider");
  }
  return context;
};

export default ApiContext;
